<template>
  <AnalyticsWidget
    title="Pending Collection"
    subTitle="Based on orders currently waiting to be collected"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">
    <div class="p-2 h-100">

      <LoadingPanel :loading="loading" />
      <div class="row pending-chart-container">
        <div class="col-12">
          <ChartBar
            :series="collectionBreakdownChartData.series"
            :xAxis="collectionBreakdownChartData.xAxis"
            :yAxis="collectionBreakdownChartData.yAxis"
            :legend="collectionBreakdownChartData.legend"
            :options="collectionBreakdownChartData.options"
            />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <Scroller maxHeight="340" height="340">
            <AnalyticsBreakdownTable>
              <template v-slot:header>
                <tr>
                  <th>Order</th>
                  <th>Contact</th>
                  <th>Despatch Ready</th>
                  <th>Days Waiting</th>
                </tr>
              </template>
              <template v-slot:body>
                <tr v-for="orderInfo of displayCollectionList" :key="orderInfo.id">
                  <td class="font-weight-bold"><LinkOrder :id="orderInfo.id" :name="orderInfo.sequenceNumber" /></td>
                  <td><LinkContact :id="orderInfo.contact.id" :name="orderInfo.contact.name" /></td>
                  <td>{{ formatDate(orderInfo.dateDespatchStarted) }}</td>
                  <td>{{ orderInfo.daysWaitingDespatch }}</td>
                </tr>
              </template>
              <template v-slot:empty v-if="displayCollectionList.length == 0">No orders found</template>
            </AnalyticsBreakdownTable>
          </Scroller>
        </div>
      </div>

    </div>
  </AnalyticsWidget>
</template>

<style scoped>
.pending-chart-container {
  height: 30%;
}
</style>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import ChartBar from '@/components/charts/chartBar'

import { TaskTypeCategoryTypes } from '@/store/types'

export default {
  name: 'OrderDIFOTPendingCollectionWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    ChartBar
  },
  props: {
    contactId: Number,
    taskType: Object,
    filter: Object,
    gridWidth: Number,
    gridHeight: Number,
  },
  computed: {
    hasContactFilter() {
      return this.contactId != null
    },
    pendingCollectionList() {
      // Only return orders with despatch type flagged as collection type
      return this.pendingOrderList.filter(order => {
        return order.despatchTaskType && order.despatchTaskType.reportingCategoryType == TaskTypeCategoryTypes.collection
      })
    },
    displayCollectionList() {
      // Limit list to max size
      return this.pendingCollectionList
    }
  },
  data() {
    return {
      loading: true,
      pendingOrderList: [],
      collectionBreakdownChartData: {
        series: [],
        xAxis: {},
        yAxis: {},
        legend: {},
        options: {}
      }
    }
  },
  watch: {
    contactId: function() {
      this.requestData()
    },
    filter: function() {
      this.requestData()
    }
  },
  mounted() {
    this.loading = true
    this.requestData()

    this.subscribeEndpoint('/orders', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
  },
  methods: {
    requestData() {
      var params = {
        contactId: this.contactId,
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null
      }

      this.$apiService.analyticsService.getOrderDIFOTPendingDespatchList(params)
      .then(response => {
        this.pendingOrderList = response.data

        // Generate breakdown data for chart
        this.generateBreakdownChartData()
      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
        console.error(err)
      })
    },
    generateBreakdownChartData() {
      const groupedBreakdownData = {
        'Same day': 0,
        '1-2 days': 0,
        '3-4 days': 0,
        '5+ days': 0
      }
      const colourList = ['#5470C6', '#91CC75', '#FAC858', '#EE6666']

      this.pendingCollectionList.forEach(order => {
        const daysNum = parseInt(order.daysWaitingDespatch || 0)
        if (daysNum <= 0) {
          groupedBreakdownData['Same day'] += 1
        } else if (daysNum <= 2) {
          groupedBreakdownData['1-2 days'] += 1
        } else if (daysNum <= 4) {
          groupedBreakdownData['3-4 days'] += 1
        } else {
          groupedBreakdownData['5+ days'] += 1
        }
      })

      this.collectionBreakdownChartData.series = [{
        name: 'Orders',
        type: 'bar',
        data: Object.values(groupedBreakdownData).map((value, index) => {
          return { value: value, itemStyle: { color: colourList[index] } }
        })
      }]
      this.collectionBreakdownChartData.xAxis = {
        data: Object.keys(groupedBreakdownData)
      }
      this.collectionBreakdownChartData.yAxis = [{
        type: 'value',
        minInterval: 1,
        axisLabel: {
          formatter: (value) => {
            return value
          }
        }
      },]
      this.collectionBreakdownChartData.legend = {
        show: true,
      }
      this.collectionBreakdownChartData.options = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        }
      }
    }
  }
}
</script>